export default __webpack_public_path__ + "static/media/Upload.05a0d582.svg";